export enum PivotDisplayUnit {
	dollars = '$ Dollars',
	thousands = '$K Thousands',
	millions = '$M Millions',
	perCapita = '$ per Capita',
	perStudent = '$ per Student',
	percentChange = '% Change',
	percentOfTotal = '% of Total'
}
